import React from "react";
import { BrowserRouter, Routes, Route, Redirect } from "react-router-dom";

import Login from "./Login/Login";
import ForgotPassword from "./Login/ForgotPassword";
import ResetPassword from "./Login/ResetPassword";
import RegisterUser from "./RegisterUser/RegisterUser";
import Container from "./Container";

const Main = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route exact path="/Login" element={<Login />} />
        <Route exact path="/Register" element={<RegisterUser />} />
        <Route exact path="/ForgotPassword" element={<ForgotPassword />} />
        <Route exact path="/ResetPassword" element={<ResetPassword />} />
        <Route exact path="/*" element={<Container />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Main;
